import { Fragment, FC } from "react";
import { Route, Switch } from "react-router-dom";
import ExternalCallback from "./ExternalCallback";
import ForgotPassword from "./ForgotPassword";
import Login from "./Login";
import Login2FA from "./Login2FA";
import LoginBrand from "./LoginBrand";
import Logout from "./Logout";
import ResetPassword from "./ResetPassword";
import PasswordChanged from "./PasswordChanged";
import EmailSended from "./EmailSended";

interface Props {
    returnUrl: string;
    tokenCode: string;
    email: string;
    logoutId: string;
}

const LoginRouter: FC<Props> = ({ returnUrl, tokenCode, email, logoutId }) => {
    //if (window.location.pathname.match(/.*\/$/)) {
    //    window.location.href = window.location.pathname.replace(/\/+$/, window.location.search)
    //}
    return (
        <Fragment>
            <Switch>
                <Route
                    exact
                    path="/login/logout"
                    children={<Logout logoutId={logoutId} />}
                />
                <Route exact path="/login/forgot">
                    <ForgotPassword returnUrl={returnUrl} />
                </Route>
                <Route exact path="/login/forgot/email">
                    <EmailSended email={email} />
                </Route>
                <Route exact path="/login/reset">
                    <ResetPassword tokenCode={tokenCode} email={email} returnUrl={returnUrl} />
                </Route>
                <Route exact path="/login/reset/password">
                    <PasswordChanged returnUrl={returnUrl}/>
                </Route>
                <Route exact path="/login/2fa">
                    <Login2FA returnUrl={returnUrl} />
                </Route>
                <Route exact path="/login/brands">
                    <LoginBrand returnUrl={returnUrl} />
                </Route>
                <Route path="/login/external/:provider">
                    <ExternalCallback returnUrl={returnUrl} />
                </Route>
                <Route path="/login">
                    <Login returnUrl={returnUrl} />
                </Route>
            </Switch>
        </Fragment>
    );
};

export default LoginRouter;
